import { useEffect, useState } from "react";

const useToken = () => {
  const storedToken = localStorage.getItem("accessToken");
  const [token, setToken] = useState(storedToken);

  useEffect(() => {
    setToken(storedToken);
  }, [storedToken]);

  return { token, setToken };
};

export default useToken;
